import { Component, Input, ChangeDetectionStrategy} from '@angular/core'

@Component({
  selector: 'icos-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <i [class]="iconName ? 'icos-icon-' + iconName : ''"></i>
  `,
})
export class IcosIcon {

  @Input('name') iconName: string

  constructor(
  ) {
  }

}
